import { c as _c } from "react/compiler-runtime";
import React from 'react';
import FavoriteViewModal from 'components/consumer/FavoriteViewModal';
import TradeUserSidebar from 'components/consumer/TradeUserSidebar/TradeUserSidebar';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import NotificationBanner from 'components/consumer/NotificationBanner';
import ChatUnavailableModal from 'components/consumer/ChatUnavailableModal';
import QuickViewModal from 'components/consumer/QuickViewModal';
import HookRunner from 'components/consumer/HookRunner';
import useToggleIsLoginSidebarOpen from 'global-state/isLoginSidebarOpen/useToggleIsLoginSidebarOpen';
import useIsLoginSidebarOpen from 'global-state/isLoginSidebarOpen/useIsLoginSidebarOpen';
import useFavoriteModalState from 'global-state/favoriteModalState/useFavoriteModalState';
import useResetFavoriteModalState from 'global-state/favoriteModalState/useResetFavoriteModalState';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useRefreshUserLocation from 'hooks/useRefreshUserLocation';
import useChatUnavailableModalState from './useChatUnavailableModalState';
import useQuickViewModalState from './useQuickViewModalState';

// The CommonModals component is used to render modals that need to be globally
// available on all pages.

// Since it is rendered on all pages (and only rendered once), it is also very
// useful to include any global hooks that need to be run on all pages. Ideally
// in future we should extract this to a separate component, named GlobalHooks.

const CommonModals = () => {
  const $ = _c(24);
  const {
    isOpen: isChatUnavailableOpen,
    close: closeChatUnavailableModal
  } = useChatUnavailableModalState();
  const {
    isOpen: isQuickViewModalOpen,
    onClose: onCloseQuickViewModal,
    path: quickViewModalPath,
    slug: quickViewModalSlug,
    productVariation: quickViewProductVariation
  } = useQuickViewModalState();
  const isLoginSidebarOpen = useIsLoginSidebarOpen();
  const toggleIsLoginSidebarOpen = useToggleIsLoginSidebarOpen();
  const favoriteModalState = useFavoriteModalState();
  const resetFavoriteModalState = useResetFavoriteModalState();
  useRefreshUserLocation();
  const showQuickViewModal = !!isQuickViewModalOpen && !!quickViewModalSlug;
  let t0;
  if ($[0] !== onCloseQuickViewModal || $[1] !== quickViewModalPath || $[2] !== quickViewModalSlug || $[3] !== quickViewProductVariation || $[4] !== showQuickViewModal) {
    t0 = showQuickViewModal && <QuickViewModal isOpen={true} onClose={onCloseQuickViewModal} path={quickViewModalPath} slug={quickViewModalSlug} variantSku={quickViewProductVariation} />;
    $[0] = onCloseQuickViewModal;
    $[1] = quickViewModalPath;
    $[2] = quickViewModalSlug;
    $[3] = quickViewProductVariation;
    $[4] = showQuickViewModal;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HookRunner />;
    t2 = <TradeUserSidebar />;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  let t3;
  if ($[8] !== favoriteModalState.isOpen || $[9] !== favoriteModalState.productId || $[10] !== resetFavoriteModalState) {
    t3 = <FavoriteViewModal isSideBarVisible={favoriteModalState.isOpen} productId={favoriteModalState.productId} onClose={resetFavoriteModalState} />;
    $[8] = favoriteModalState.isOpen;
    $[9] = favoriteModalState.productId;
    $[10] = resetFavoriteModalState;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== isLoginSidebarOpen || $[13] !== toggleIsLoginSidebarOpen) {
    t4 = <LoginSidebar show={isLoginSidebarOpen} onClose={toggleIsLoginSidebarOpen} />;
    $[12] = isLoginSidebarOpen;
    $[13] = toggleIsLoginSidebarOpen;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NotificationBanner />;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== closeChatUnavailableModal || $[17] !== isChatUnavailableOpen) {
    t6 = <ChatUnavailableModal isOpen={isChatUnavailableOpen} onClose={closeChatUnavailableModal} />;
    $[16] = closeChatUnavailableModal;
    $[17] = isChatUnavailableOpen;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t0 || $[20] !== t3 || $[21] !== t4 || $[22] !== t6) {
    t7 = <>{t0}{t1}{t2}{t3}{t4}{t5}{t6}</>;
    $[19] = t0;
    $[20] = t3;
    $[21] = t4;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export default withBrowserOnly(CommonModals);